import React, { useState } from "react";
import Layout from "../components/Layout";
import SEO from "../components/SEO";
import { businessInfo } from "../constants";
import { MapPin, Phone, Mail, Clock, MessageCircle, Send } from "lucide-react";
import { useToast } from "../hooks/use-toast";

export default function Contact() {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "" });
  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone) { toast({ title: "Fill in name and phone" }); return; }
    const text = encodeURIComponent(`Hello Revive Solutions,\n\nName: ${form.name}\nPhone: +91 ${form.phone}\nEmail: ${form.email}\n\n${form.message}`);
    window.open(`${businessInfo.whatsapp}?text=${text}`, "_blank");
    toast({ title: "Opening WhatsApp", description: "We'll get back to you shortly." });
    setForm({ name: "", phone: "", email: "", message: "" });
  };

  return (
    <Layout>
      <SEO title="Contact Revive Solutions | Elica Service Centre Pune" description="Contact Revive Solutions in Wanowrie, Pune. Phone, WhatsApp, email and office address for authorised Elica service." canonical="/contact" />
      <section className="bg-[#0b1220] text-white py-14">
        <div className="max-w-5xl mx-auto px-6">
          <div className="chip chip-dark mb-4">Get in touch</div>
          <h1 className="font-display text-4xl md:text-5xl font-medium leading-tight mb-3">We&apos;re here to help</h1>
          <p className="text-white/70 max-w-2xl">Fastest way to reach us is WhatsApp. Prefer email or a call? All our channels are below.</p>
        </div>
      </section>
      <section className="py-14 bg-white">
        <div className="max-w-5xl mx-auto px-6 grid lg:grid-cols-2 gap-12">
          <div>
            <h2 className="font-display text-2xl md:text-3xl font-medium mb-6">Contact details</h2>
            <div className="space-y-5 mb-8">
              <Row icon={MapPin} title="Address" value={businessInfo.address} />
              <Row icon={Phone} title="Phone" value={<a href={`tel:${businessInfo.phone}`} className="hover:text-[#e30613]">{businessInfo.phoneDisplay}</a>} />
              <Row icon={MessageCircle} title="WhatsApp" value={<a href={businessInfo.whatsapp} target="_blank" rel="noreferrer" className="hover:text-[#25D366]">{businessInfo.phoneDisplay}</a>} />
              <Row icon={Mail} title="Email" value={<a href={`mailto:${businessInfo.email}`} className="hover:text-[#e30613] break-all">{businessInfo.email}</a>} />
              <Row icon={Clock} title="Business Hours" value={businessInfo.hours} />
            </div>
            <div className="rounded-lg overflow-hidden border border-neutral-200 aspect-[16/10]">
              <iframe title="Revive Solutions Location" src={businessInfo.mapEmbed} className="w-full h-full" loading="lazy" style={{ border: 0 }} allowFullScreen referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
          </div>
          <form onSubmit={submit} className="bg-neutral-50 border border-neutral-200 rounded-lg p-6 md:p-8">
            <h3 className="font-display text-2xl mb-6">Send us a message</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div><label className="field-label">Name*</label><input name="name" value={form.name} onChange={onChange} className="field" placeholder="Your name" /></div>
              <div><label className="field-label">Phone*</label><input name="phone" value={form.phone} onChange={onChange} className="field" placeholder="10-digit" inputMode="numeric" /></div>
              <div className="md:col-span-2"><label className="field-label">Email</label><input name="email" type="email" value={form.email} onChange={onChange} className="field" placeholder="you@email.com" /></div>
              <div className="md:col-span-2"><label className="field-label">Message</label><textarea name="message" value={form.message} onChange={onChange} rows="4" className="field resize-none" placeholder="How can we help?"></textarea></div>
            </div>
            <button type="submit" className="btn-primary mt-5 w-full justify-center">Send via WhatsApp <Send className="w-4 h-4" /></button>
          </form>
        </div>
      </section>
    </Layout>
  );
}

function Row({ icon: Icon, title, value }) {
  return (
    <div className="flex items-start gap-4">
      <div className="w-10 h-10 rounded-md bg-[#fef2f2] text-[#e30613] grid place-items-center flex-shrink-0"><Icon className="w-5 h-5" /></div>
      <div>
        <div className="text-xs uppercase tracking-wider text-slate-500 mb-0.5">{title}</div>
        <div className="text-[15px]">{value}</div>
      </div>
    </div>
  );
}
